import { useContent } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { getInHandDisplayData } from 'src/utils/saleUtils';
import { Feature } from 'src/WebApiController';

import { inhandDateContainer } from './InHandDateDisplay.css';

export function InHandDateDisplay({
  date,
  needsToFulfill,
  handleFulfillmentState,
  showAbsoluteDate = false,
}: {
  date?: Date | null;
  needsToFulfill?: boolean;
  handleFulfillmentState?: boolean;
  showAbsoluteDate?: boolean;
}) {
  const inhand = useContent(ContentId.InHand);
  const ihdTimezoneFix = useUserHasFeature(Feature.IhdTimezoneFix);
  const dateLocal = ihdTimezoneFix
    ? date
    : date &&
      new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        )
      );

  const { displayText, displayTooltip, alertIcon } = getInHandDisplayData(
    inhand,
    dateLocal,
    new Date(),
    needsToFulfill,
    showAbsoluteDate
  );

  if (!needsToFulfill && handleFulfillmentState) {
    return null;
  }

  return (
    <div title={displayTooltip ?? undefined} className={inhandDateContainer}>
      {handleFulfillmentState && alertIcon}
      <span>{displayText}</span>
    </div>
  );
}
